import axios from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';

import { getRSSLink } from '../../../api/channels';

import {
  checkAndSetLoadingWithId,
  handleRequestRejection,
  onMatchedRequest,
} from '../../../utils/asyncThunkRequest';
import { generateLinkCIDKey } from '../../../components/Items/utils/generateLinkCIDKey';

export const fetchRSSLink = createAsyncThunk(
  'channels/fetchRSSLink',
  async (linkData, { signal, rejectWithValue }) => {
    const source = axios.CancelToken.source();
    signal.addEventListener('abort', () => {
      source.cancel();
    });
    try {
      const response = await getRSSLink(linkData, {
        cancelToken: source.token,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.status);
    }
  },
);

export const fetchRSSLinkExtraReducers = builder => {
  builder
    .addCase(fetchRSSLink.pending, (state, action) => {
      checkAndSetLoadingWithId(
        state.rssLinks.request,
        action,
        generateLinkCIDKey(action.meta.arg.path),
      );
    })
    .addCase(fetchRSSLink.fulfilled, (state, action) => {
      const linkCIDKey = generateLinkCIDKey(action.meta.arg.path);

      onMatchedRequest(state.rssLinks.request[linkCIDKey], action, () => {
        state.rssLinks.byId[linkCIDKey] = {
          ...action.payload,
          linkId: action.payload.id,
          id: linkCIDKey,
        };

        if (!state.rssLinks.allIds.includes(linkCIDKey)) {
          state.rssLinks.allIds.push(linkCIDKey);
        }
      });
    })
    .addCase(fetchRSSLink.rejected, (state, action) => {
      handleRequestRejection(
        state.rssLinks.request[generateLinkCIDKey(action.meta.arg.path)],
        action,
      );
    });
};
